<template>
  <div class="single-job-sidebar">
    <v-card tile elevation="0" class="single-job-sidebar-card">
      <template v-if="jobLocation">
        <div class="job-thumbnail">
          <img :src="jobLocation.img_src" :alt="jobLocation.name">
        </div>

        <h3 class="job-location">
          {{ jobLocation.name }}
          <span class="job-parent-location">{{ jobLocation.parent }}</span>
        </h3>

        <v-divider/>

        <div class="job-data">
          <p>{{ jobLocation.meta.address }}</p>
          <p><b>Phone: </b> {{ jobLocation.meta.phone }}</p>
        </div>
      </template>

      <v-divider/>

      <div class="contact-form">
        <h3 class="contact-form-title">Contact Form</h3>

        <div id="jobs-contact-form-dist"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import {moveElement} from '../../../utils';

export default {
  name: 'Sidebar',
  props: {
    job: Object
  },
  computed: {
    jobLocation() {
      return this.job.meta ? this.job.meta.find(el => el.taxonomy === 'pj_locations') : null;
    }
  },
  mounted() {
    this.$nextTick(function () {
      moveElement('jobs-contact-form', 'jobs-contact-form-dist');
    })
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.single-job-sidebar {

  &-card {
    padding: 20px;
  }

  .job-thumbnail {
    border: 1px solid #979797;
    width: 200px;
    height: 200px;
    margin: 0 auto 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 80%;
      height: 80%;
    }
  }

  .job-location {
    color: #243759;
    font-family: "Zilla Slab";
    font-size: 32px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
    text-align: center;
    margin-bottom: 20px;
    margin-top: 0;
  }

  .job-parent-location {
    color: #4A4A4A;
    font-family: "Avenir";
    font-size: 16px;
    font-style: italic;
    letter-spacing: 0;
    line-height: 26px;
    font-weight: normal;
    display: block;
  }

  .job-data {
    color: #4A4A4A;
    font-family: "Avenir";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin: 20px 0;
  }

  .contact-form {

    &-title {
      color: #243759;
      font-family: "Zilla Slab";
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 0.34px;
      line-height: 29px;
      margin: 20px 0;
    }
  }
}
</style>
